import { useState } from "react";
import { toast } from "sonner";
import { api, formatError, formatDate, useApi } from "@/lib/api";
import { AdminTitle, StatusPill } from "./AdminUi";

export default function AdminEnquiries() {
  const [type, setType] = useState("general");
  const { data, reload } = useApi(`/admin/enquiries?type=${type}`);
  const update = async (id, status) => {
    try { await api.patch(`/admin/enquiries/${id}`, { status }); toast.success("Status updated"); reload(); } catch (e) { toast.error(formatError(e)); }
  };
  const remove = async (id) => {
    if (!window.confirm("Permanently delete this enquiry?")) return;
    try { await api.delete(`/admin/enquiries/${id}`); toast.success("Enquiry deleted"); reload(); } catch (e) { toast.error(formatError(e)); }
  };
  return (
    <div data-testid="admin-enquiries">
      <AdminTitle title="Enquiries">Private messages from the public. Viewing and changes are recorded in the audit log. Delete enquiries once they're no longer needed.</AdminTitle>
      <div className="mb-5 flex gap-2">
        {[["general", "General enquiries"], ["partnership", "Partnership interest"]].map(([v, l]) => (
          <button key={v} onClick={() => setType(v)} className={`rounded-full px-4 py-2 text-sm font-semibold border ${type === v ? "bg-ink text-cream" : "bg-white"}`} data-testid={`enquiries-tab-${v}`}>{l}</button>
        ))}
      </div>
      {data?.length === 0 && <p className="card-soft !bg-white p-6 text-ink-soft" data-testid="enquiries-empty">No enquiries yet.</p>}
      <ul className="space-y-4">
        {(data || []).map((e) => (
          <li key={e.id} className="card-soft !bg-white p-5" data-testid={`enquiry-item-${e.id}`}>
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <p className="font-semibold">{e.name} · <a href={`mailto:${e.email || e.work_email}`} className="text-teal underline">{e.email || e.work_email}</a></p>
                <p className="text-sm text-ink-muted">{formatDate(e.created_at)} · {e.type === "partnership" ? `${e.organisation} (${e.organisation_type}) · ${e.area_of_interest}` : e.topic}</p>
              </div>
              <div className="flex items-center gap-2">
                <StatusPill status={e.status} />
                <select aria-label="Change status" value={e.status} onChange={(ev) => update(e.id, ev.target.value)} className="rounded-lg border px-2 py-1.5 text-sm" data-testid={`enquiry-status-${e.id}`}>
                  <option value="new">New</option><option value="in_progress">In progress</option><option value="closed">Closed</option>
                </select>
                <button onClick={() => remove(e.id)} className="btn-ghost !text-clay-dark text-sm" data-testid={`enquiry-delete-${e.id}`}>Delete</button>
              </div>
            </div>
            <p className="mt-3 whitespace-pre-wrap text-ink-soft">{e.message}</p>
          </li>
        ))}
      </ul>
    </div>
  );
}
